import React, { useState } from "react";
import {
  Select,
  MenuItem,
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  FormControl,
  InputLabel,
} from "@mui/material";

const PreviewSelect = (props) => {
  const { handleClose, open, filter } = props;

  const [value, setValue] = useState(null);

  return (
    <Dialog fullWidth aria-labelledby="form-dialog-title" open={open} onClose={handleClose}>
      <DialogTitle id="form-dialog-title">{`Preview Filter: ${filter.name}`}</DialogTitle>
      <DialogContent>
        <FormControl fullWidth variant="outlined">
          <InputLabel id="preview">{filter.name}</InputLabel>
          <Select
            fullWidth
            id={filter.name}
            label={filter.name}
            labelId="preview"
            value={value}
            onChange={(event) => setValue(event.target.value)}
          >
            {filter.filterValues &&
              filter.filterValues.map((fv, i) => (
                <MenuItem key={`MenuItem-${fv.value}-${i}`} value={fv.value}>
                  {fv.label}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={handleClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PreviewSelect;
